import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './assets/common/rem'
import 'amfe-flexible/index.js'
import '@/assets/style/common.less'
import LANGZH from '@/assets/lang/zh-cn.js'
import LANGEN from '@/assets/lang/en-us.js'
import config from '@/config'
import moment from 'moment'
import { Locals } from '@/assets/lang/vantLocal'
import md5 from 'js-md5'

import {
  Button,
  NavBar,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  List,
  PullRefresh,
  Divider,
  Icon,
  Skeleton,
  Search,
  Popup,
  TreeSelect,
  Image as VanImage,
  Form,
  Field,
  Calendar,
  Toast,
  Dialog,
  Col,
  Row,
  Grid,
  GridItem,
  PasswordInput,
  NumberKeyboard,
  Uploader,
  ImagePreview,
  DropdownMenu,
  DropdownItem,
  Empty,
  Picker,
  Loading,
  SwipeCell,
  Cell,
  CellGroup,
  Overlay,
  Circle,
  DatetimePicker,
  Checkbox
} from 'vant'
import VueI18n from 'vue-i18n'
import Vue2TouchEvents from 'vue2-touch-events'
import echarts from 'echarts'

Vue.use(Button).use(List).use(PullRefresh).use(Divider).use(Icon).use(Skeleton).use(Popup).use(TreeSelect).use(VanImage).use(Calendar).use(Toast).use(Dialog).use(Picker).use(DatetimePicker).use(Checkbox)
Vue.use(NavBar).use(Tabbar).use(TabbarItem).use(Swipe).use(SwipeItem).use(Tab).use(Tabs).use(Col).use(Row).use(Grid).use(GridItem).use(Empty).use(SwipeCell).use(Cell).use(CellGroup)
Vue.use(Search).use(Form).use(Field).use(PasswordInput).use(NumberKeyboard).use(Uploader).use(ImagePreview).use(DropdownMenu).use(DropdownItem).use(Loading).use(Overlay).use(Circle)
Vue.use(VueI18n)
Vue.use(Vue2TouchEvents)

Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.$moment = moment
Vue.prototype.$local = Locals
Vue.prototype.$preview = ImagePreview
Vue.prototype.$md5 = md5
Vue.prototype.$echarts = echarts

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    zh: LANGZH,
    en: LANGEN
  }
})

Toast.setDefaultOptions({
  position: 'bottom'
})

Toast.setDefaultOptions('loading', { position: 'middle', forbidClick: true })

/**
 * @description
 * @author (Set the text for this tag by adding docthis.authorName to your settings file.)
 * @date 2019-05-29
 * @param { number } type 1 localStorage 2 sessionStorage
 * @param { string } key 键
 * @param { string } data 要存储的数据
 * @returns
 */
// 如果报prototype无法被识别的错误，可以把原型方法挂在到__proto__
Vue.prototype.$addStorageEvent = function (type, key, data) {
  if (type === 1) {
    // 创建一个StorageEvent事件
    const newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, data)
  } else {
    // 创建一个StorageEvent事件
    const newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, data)
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
